import { z } from 'zod';
import { findInvalidPlaceholders } from '../types/email-template.js';

/**
 * Portal PUT body for a New Western email template override.
 * Plain text only — the branded HTML shell is fixed in code, so template
 * content is escaped at render time and cannot inject markup.
 */
export const nwEmailTemplateUpdateSchema = z
  .object({
    subject: z.string().min(1, 'Subject is required').max(200),
    heading: z.string().max(150),
    body: z.string().min(1, 'Body is required').max(5000),
  })
  .strict()
  .superRefine((val, ctx) => {
    for (const field of ['subject', 'heading', 'body'] as const) {
      const invalid = findInvalidPlaceholders(val[field]);
      if (invalid.length > 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: [field],
          message: `Unknown placeholder(s): ${invalid.map((t) => `{{${t}}}`).join(', ')}`,
        });
      }
    }
  });

export type NwEmailTemplateUpdateInput = z.infer<typeof nwEmailTemplateUpdateSchema>;
